import {
  IPartnersListParams,
  PartnerStatus,
} from "~/entity/Partners/model/schema";
import { IPartnersFilterForm } from "~/pages/Partners/PartnersFilter";
import { toApiDateEnd, toApiDateStart } from "~/shared/lib/filterHelpers";

import { mapPartnerStatusToApi } from "./partnerStatus";

export const mapPartnersFilterToQuery = (
  page: number,
  count: number,
  filter: IPartnersFilterForm,
): IPartnersListParams => ({
  page,
  count,
  id: filter.id || undefined,
  name: filter.name || undefined,
  inn: filter.inn || undefined,
  status: filter.status?.value
    ? mapPartnerStatusToApi(filter.status.value as PartnerStatus)
    : undefined,
  createdAtFrom: toApiDateStart(filter.createdFrom),
  createdAtTo: toApiDateEnd(filter.createdTo),
  country: filter.country?.value || undefined,
  federalDistrict: filter.fo?.value || undefined,
  region: filter.region?.value || undefined,
  city: filter.city?.value || undefined,
});
